import {
    ContactContainer,
    Contacts,
    GoogleMaps,
} from "./contact.styles"
import phone from "../../assets/icons/phone.svg"
import location from "../../assets/icons/location-icon.svg"
import mail from "../../assets/icons/mail.svg"
import map from "../../assets/img/map.jpg"
import clock from "../../assets/icons/clock.svg"
import "./styles.scss"

const Contact = ({props}) => {
    return (
        <ContactContainer id="contacts">
            <h2>{props[1]}</h2>
            <Contacts>

                <ul>
                    <li className="contact-phones">
                        <img src={phone} alt=""/>
                        <a href="tel:+37369107497"><span>069 107 497</span></a>
                    </li>
                    <li>
                        <img src={mail} alt=""/>
                        <a href="mailto:autochip.contact@gmail.com"><span>autochip.contact@gmail.com</span></a>
                    </li>
                    <li>
                        <img src={location} alt=""/>
                        <span><a
                            href="https://maps.app.goo.gl/r6SVKsCPjRwEsQXm9" target="_blank"
                            rel="noreferrer noopener">{props[2]}</a></span>
                    </li>
                    <li>
                        <img src={clock} alt=""/>
                        <span>{props[3]}</span>
                    </li>
                </ul>
            </Contacts>
            <a
                href="https://maps.app.goo.gl/r6SVKsCPjRwEsQXm9"
                target="_blank"
                rel="noreferrer noopener"
            >
                <GoogleMaps>
                    <img src={map} alt=""/>

                </GoogleMaps>
            </a>
            {/* <div className="bank-details">
                <span className="bank-details_header">{props.requisites}</span>
                <div className="cols-wrapper">
                    <div className="left-col">
                    <span>"carlab-rechizite</span>
                    </div>
                    <div className="right-col">
                    <span>rechizite 2</span>
                    </div>
                </div>
            </div> */}
            {/* <Attention>
        <img src={attention} alt="" />
        {props[3]}
      </Attention> */}

        </ContactContainer>
    )
}

export default Contact
